import { render, staticRenderFns } from "./FilesHeader.vue?vue&type=template&id=0f0002d2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f0002d2')) {
      api.createRecord('0f0002d2', component.options)
    } else {
      api.reload('0f0002d2', component.options)
    }
    module.hot.accept("./FilesHeader.vue?vue&type=template&id=0f0002d2&", function () {
      api.rerender('0f0002d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/components/FilesHeader.vue"
export default component.exports